<template>
	<div class="steps__step-form">
		<p class="mb-24">
			Pre-fill this form using the information already in PandaDoc
		</p>
		<form
			class="form form--fixed-fields"
			@submit.prevent="updateForm"
		>
			<InputComponent
				:value="form_fields.pandadoc_id"
				type="text"
				input-id="pandadoc-id"
				name="pandadoc-id"
				label="PandaDoc document ID"
				:required="true"
				:errors="form_errors.pandadoc_id || null"
				@update:value="( value ) => form_fields.pandadoc_id = value"
			/>
			<button
				class="button button--fill"
				type="submit"
			>
				Fetch information and continue
			</button>
		</form>
	</div>
</template>

<script setup>
import { useAddProjectScopeStore } from '../../stores/add-project-scope.js';
import { ref, defineProps, defineEmits } from 'vue';
import { storeToRefs } from 'pinia';
import InputComponent from '../InputComponent';

const emit = defineEmits( ['complete-form'] );

const add_project_scope_store = useAddProjectScopeStore();
const { getPandaDocInfo } = add_project_scope_store;
const {
	form_fields,
	form_errors
} = storeToRefs( add_project_scope_store );

defineProps( {
	stepTitle: {
		required: true,
		type: String,
		default: ''
	}
} );

const loading = ref( true );

async function updateForm() {
	loading.value = true;

	await getPandaDocInfo();

	if ( form_errors['pandadoc_id'] || !form_fields.value.project_scope ) {
		loading.value = false;
		return;
	}

	emit( 'complete-form' );
	loading.value = false;
}

</script>
